<template>
    <div class="qzsy-table-container">
        <table class="qzsy-table">
            <thead>
                <tr>
                    <th>星</th>
                    <th>宿</th>
                    <th>速</th>
                    <th>宫</th>
                    <th>殿</th>
                    <th>垣</th>
                    <th>庙</th>
                    <th>旺</th>
                    <th>乐</th>
                    <th>喜</th>
                    <th>管库星</th>
                    <th>化曜</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in data" :key="index">
                    <td>{{ item.xing || '' }}</td>
                    <td>{{ `${item.su1 || ''}${item.su || ''}${item.su2 || ''}` }}</td>
                    <td>{{ item.shu || '' }}</td>
                    <td>{{ `${item.gong1 || ''}${item.gong || ''}${item.gong2 || ''}` }}</td>
                    <td>{{ item.dian || '' }}</td>
                    <td>{{ item.yuan || '' }}</td>
                    <td>{{ item.miao || '' }}</td>
                    <td>{{ item.wang || '' }}</td>
                    <td>{{ item.le || '' }}</td>
                    <td>{{ item.xi || '' }}</td>
                    <td>{{ item.guan || '' }}</td>
                    <td>{{ item.hua || '' }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script setup>
import { defineProps } from 'vue';

defineProps({
    data: {
        type: Array,
        default: () => []
    }
})
</script>

<style scoped>
.qzsy-table-container {
    overflow-x: auto;
}

.qzsy-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
    border: 1px solid #444;
    color: #fff;
}

.qzsy-table th,
.qzsy-table td {
    padding: 10px 8px;
    border: 1px solid #444;
    text-align: center;
    min-width: 60px;
}

.qzsy-table th {
    background-color: #33334d;
    font-weight: bold;
    color: #b0a0ff;
}

.qzsy-table tr:nth-child(even) {
    background-color: rgba(40, 40, 60, 0.5);
}

.qzsy-table tr:nth-child(odd) {
    background-color: rgba(30, 30, 45, 0.5);
}

.qzsy-table tr:hover {
    background-color: rgba(110, 90, 210, 0.2);
}
</style>